import { Flame, Snowflake, Wind, PenTool, Wrench, MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { useLanguage } from "@/hooks/useLanguage";

const ServicesSection = () => {
  const { ref, isVisible } = useScrollAnimation(0.1);
  const { t } = useLanguage();

  const services = [
    { icon: Flame, title: t("service.apkure"), desc: t("services.apkure.desc"), href: "/apkure" },
    { icon: Snowflake, title: t("service.kondicionieri"), desc: t("services.kondicionieri.desc"), href: "/kondicionieri" },
    { icon: Wind, title: t("service.ventilacija"), desc: t("services.ventilacija.desc"), href: "/ventilacija" },
    { icon: PenTool, title: t("service.projektesana"), desc: t("services.projektesana.desc"), href: "/projektesana" },
    { icon: Wrench, title: t("service.serviss"), desc: t("services.serviss.desc"), href: "/serviss" },
    { icon: MessageSquare, title: t("service.konsultacijas"), desc: t("services.konsultacijas.desc"), href: "/konsultacijas" },
  ];

  return (
    <section id="pakalpojumi" className="py-16 sm:py-20 bg-[hsl(var(--brand-navy))]">
      <div className="container mx-auto px-4" ref={ref}>
        <h2
          className={`text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-4 text-white transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          {t("services.title")}
        </h2>
        <p
          className={`text-center text-blue-200 mb-10 sm:mb-12 max-w-2xl mx-auto text-sm sm:text-base transition-all duration-700 delay-100 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          {t("services.desc")}
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {services.map((s, i) => (
            <Link
              key={s.title}
              to={s.href}
              className={`bg-white/5 backdrop-blur-sm rounded-xl p-5 sm:p-6 border border-white/10 hover:bg-white/10 hover:-translate-y-2 hover:shadow-xl hover:shadow-primary/10 transition-all duration-300 cursor-pointer group no-underline ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{
                transitionDelay: isVisible ? `${150 + i * 100}ms` : "0ms",
                transitionProperty: "all",
                transitionDuration: "600ms",
              }}
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-primary/20 flex items-center justify-center mb-3 sm:mb-4 group-hover:bg-primary/30 group-hover:scale-110 transition-all duration-300">
                <s.icon className="w-5 h-5 sm:w-6 sm:h-6 text-blue-300" />
              </div>
              <h3 className="text-base sm:text-lg font-semibold mb-2 text-white">{s.title}</h3>
              <p className="text-xs sm:text-sm text-blue-200 leading-relaxed">{s.desc}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
